import { createSlice } from '@reduxjs/toolkit';

import type { RootState } from '../store';

const initialState = {
  statuses: [],
};

export const statusesSlice = createSlice({
  name: 'statutes',
  initialState,
  reducers: {
    setStatues(state, action) {
      state.statuses = action.payload;
    },
  },
});

export const getState = (rootState: RootState) => rootState.statuses;

export const { setStatues } = statusesSlice.actions;
